import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import GroupsIcon from '@mui/icons-material/Groups';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import MenuItemDescriptionTypography from 'components/MenuItemDescriptionTypography';
import HelpToolTip from 'components/HelpToolTip';
import { HOW_IT_WORKS } from 'bento-ordering/group_ordering/constants/groupOrder';

const StyleHowItWorks = styled(MenuItemDescriptionTypography)(({ theme }) => ({
  display: 'block',
  fontFamily: theme.typography.fontFamily,
  fontWeight: '450',
  fontSize: '14px'
}));

const StyledHowItWorkText = styled(MenuItemDescriptionTypography)(
  ({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    color: theme.palette.white,
    fontFamily: theme.typography.fontFamily,
    fontWeight: '450',
    fontSize: '12px'
  })
);

export const HowItWorksDescription = () => (
  <Box p="16px 8px">
    <StyledHowItWorkText component="span" pb="8px">
      <GroupsIcon />
      <Box ml="8px">{HOW_IT_WORKS.description.inviteGuest}</Box>
    </StyledHowItWorkText>
    <StyledHowItWorkText component="span">
      <AttachMoneyIcon />
      <Box ml="8px">{HOW_IT_WORKS.description.payFor}</Box>
    </StyledHowItWorkText>
  </Box>
);

const HowItWorks = ({ bottomMargin = '0' }) => (
  <Box display="flex" mt="8px" mb={bottomMargin}>
    <StyleHowItWorks
      {...{ variant: ITEM_DESCRIPTION_AND_PRICES }}
      data-testid="tooltip-tax"
    >
      {HOW_IT_WORKS.label}
    </StyleHowItWorks>
    <Box ml="3px">
      <HelpToolTip data-testid="taxes-tooltip" maxWidth={270}>
        <HowItWorksDescription />
      </HelpToolTip>
    </Box>
  </Box>
);

HowItWorks.propTypes = {
  bottomMargin: PropTypes.string
};

export default HowItWorks;
